<template>
  <div class="root" id="root" data-target="specialFeature-1691834599183">
    <div class="hCnVKxh5ABYzPjWWu0rH">
<!--      <div class="zAsCjLdh1d8SdqBcjnJY">-->
<!--        <div class="rndx react-draggable"-->
<!--             style="position: absolute; user-select: auto; width: 36px; height: 36px; display: inline-block; top: 0px; left: 0px; cursor: move; transform: translate(380px, 400px); max-width: 9.0072e+15px; max-height: 9.0072e+15px; box-sizing: border-box; flex-shrink: 0;">-->
<!--          <img class="icon" src="/webx/xc/mobile/images/outcache/Rocket@3x.6c18.png">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="overlay" style="display: none;"></div>-->
<!--      </div>-->
      <div id="captcha-button"></div>
      <div id="captcha-element"></div>
      <div id="captcha-wy"></div>
<!--      <div class="fBzbGiSmgDKW5YKdSO19">-->
<!--        <div class="rndxs react-draggable"-->
<!--             style="position: absolute; user-select: auto; width: 36px; height: 36px; display: inline-block; top: 0px; left: 0px; cursor: auto; transform: translate(380px, 450px); max-width: 9.0072e+15px; max-height: 9.0072e+15px; box-sizing: border-box; flex-shrink: 0;">-->
<!--          <img class="icon" src="/webx/xc/mobile/images/outcache/icon.2af9.png">-->
<!--          <div></div>-->
<!--        </div>-->
<!--        <div class="overlay" style="display: none;"></div>-->
<!--      </div>-->
      <div class="CAkqQEYYNHqOOJDFEr3i">
        <div class="top-tips">
          <p>说明：*为必填信息</p>
        </div>
        <ul>
          <li class="item usd_type">
            <div class="label_box">
              <p><i>*</i>货币类型：</p>
              <ul>
                <li  v-for="(item, index) in usdt_type" :key="index"   :class="pay_way == item.value ? ' active' : ''" @click="changPayway(item.value)" >{{item.value}}</li>

              </ul>
            </div>
            <div class="tips usdt_tips"></div>
          </li>
          <li class="item">
            <div class="label_box"><label for=""><i>*</i>提现钱包地址：</label><input v-model="acount" type="text" class=""
                                                                                     placeholder="输入钱包地址" value=""></div>
            <div class="tips"></div>
          </li>
          <li class="item">
            <div class="label_box"><label for=""><i>*</i>确认钱包地址：</label><input v-model="acount_agent" type="text" class=""
                                                                                     placeholder="确认钱包地址" value=""></div>
            <div class="tips"></div>
          </li>
          <li class="item">
            <div class="label_box">
              <label for=""><i>*</i>支付密码：</label>
              <input v-model="cardInfo.pay_pass" type="password" class=""
                     placeholder="输入支付密码" value="">
            </div>
            <div class="tips"></div>
          </li>


          <li class="item">
            <div class="footer"  @click="bindCard"><span class="button next">下一步</span></div>
          </li>
        </ul>
      </div>
    </div>


    <div class="portal-warpper">
      <div class="HZ0Aws4BaQP_ZM85k_mS undefined" style="display: flex;">
        <div class="left" @click="$router.back()"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left"
                               class="svg-inline--fa fa-chevron-left " role="img" xmlns="http://www.w3.org/2000/svg"
                               viewBox="0 0 320 512" style="margin: 0px 4px;">
          <path fill="currentColor"
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z">
          </path>
        </svg></div>
        <div class="center">添加虚拟账户</div>
        <div class="right"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'addBankCard',
  data() {
    return {
      acount:'',
      acount_agent:'',
      pay_way:'TRC20',
      usdt_type:[],
      cardInfo: {},
      banklist: [],
      show: false,
    };
  },
  created() {
    let that = this;
    that.getBanklist();
  },
  methods: {
    changPayway(val){
      this.pay_way = val;
    },
    changShow() {
      this.show = !this.show;
    },
    onConfirm(value, index) {
      this.cardInfo.bank = value.bank_name;
      console.log(this.cardInfo.bank);
      this.show = false;
    },
    onChange(picker, value, index) {},
    onCancel() {
      this.show = false;
    },
    getBanklist() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun
          .post('/api/getReType', {})
          .then(res => {
            if (res.code != 200) {
              that.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.usdt_type = res.data.usdt_type;
              that.pay_way = that.usdt_type[0].value
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
    bindCard() {


      let that = this;


      if (!that.acount) {
        that.$parent.showTost(0, '钱包地址');
        return;
      }


      if (that.acount != that.acount_agent) {
        that.$parent.showTost(0, '两次钱包地址不一致');
        return;
      }

      that.cardInfo.bank = 'USDT';
      that.cardInfo.bank_owner = that.pay_way;

      that.cardInfo.bank_no = that.acount;
      that.cardInfo.bank_address = that.pay_way;





      if (that.cardInfo.pay_pass.length < 6 || that.cardInfo.pay_pass.length > 18) {
        that.$parent.showTost(0, '请输人支付密码长度');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun
          .post('/api/bindcard', that.cardInfo)
          .then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.$parent.showTost(1, '绑定成功');
              that.$router.back();
            }
            that.$parent.hideLoading();
          })
          .catch(res => {
            that.$parent.hideLoading();
          });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>

.footer {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.button {
  height: 1.5rem;
  line-height:  1.5rem;
  width: 100%;
  margin-top: .53333rem;
  color: #fff;
  text-align: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: .6rem;
  border-radius: 1.5rem;
  background: linear-gradient(306deg, #593f6c 0%, #947be7 100%);
}

.button.next.mgc {
  margin: 0 auto;
}


.usrse {
  background: #fff;
  box-sizing: border-box;
  padding: 6px 20px 0;
  .nams {
    font-size: 0.38rem;
    color: #000;
    vertical-align: middle;
    margin-top: 10px;
    font-weight: 700;
  }
  .imgsa {
    position: relative;
    height: 2rem;
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 0.2rem;
    .bisn {
      width: 0.8rem;
      position: absolute;
      bottom: 0.3rem;
      left: 1.4rem;
    }
    img {
      width: 2rem;
      border-radius: 50%;
    }
  }
}
[class*='van-hairline']:after {
  border: none;
}



body>div#root {
  height: 100%;
  overflow: hidden;
  background-color: #fafaff;
}


.hCnVKxh5ABYzPjWWu0rH {
  width: 100%;
  height: 100%;
  background-size: 100% auto;
  background-repeat: repeat;
  background: #fff;
}

body>div#root>div {
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: auto;
}

div, span, a {
  user-select: none;
  -webkit-overflow-scrolling: touch;
}


.zAsCjLdh1d8SdqBcjnJY .rndx {
  position: relative;
  z-index: 199;
}


.zAsCjLdh1d8SdqBcjnJY .overlay {
  width: 100%;
  height: 100vh;
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  overflow: hidden;
}


.fBzbGiSmgDKW5YKdSO19 .rndxs {
  position: relative;
  z-index: 199;
}


.overlay {
  width: 100%;
  height: 100vh;
  opacity: 0;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 100;
  overflow: hidden;
}

.CAkqQEYYNHqOOJDFEr3i {
  width: 100%;
  padding-top: 40px;
  padding-bottom: 20px;
  height: calc(100% - 60px);
  overflow-y: auto;
}

.CAkqQEYYNHqOOJDFEr3i .top-tips {
  margin-top: 12px;
  margin-bottom: 15px;
  background-color: #ca9be6;
}

.CAkqQEYYNHqOOJDFEr3i .top-tips p {
  color: #fff;
  font-size: .6rem;
  height: 1.2rem;
  line-height: 1.2rem;
  background-repeat: no-repeat;
  background-size: auto 60%;
  background-position: 10px center;
  padding-left: 1.4rem;
}

.CAkqQEYYNHqOOJDFEr3i>ul {
  width: 100%;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item {
  margin-bottom: 12px;
  padding-left: 15px;
  padding-right: 15px;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type {
  border-bottom: 10px solid rgba(226, 226, 226, .37);
  padding-bottom: 15px;
}


.CAkqQEYYNHqOOJDFEr3i>ul .item .label_box {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .label_box {
  justify-content: flex-start;
  align-items: flex-start;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .label_box>p {
  margin-bottom: 5px;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .label_box>ul {
  display: flex;
}
.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .label_box>ul li {
  height: 1.24rem;
  line-height: 1.24rem;
  padding: 0 .3rem;
  background: linear-gradient(180deg, rgba(240, 234, 255, 0.53) 0%, #ECE8FF 100%);
  border-radius: 4px;
  color: #c4b2ff;
  margin-right: 10px;
}


.CAkqQEYYNHqOOJDFEr3i>ul .item .tips {
  color: #99a0b1;
  margin-top: 4px;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .usdt_tips {
  color: red;
}


.CAkqQEYYNHqOOJDFEr3i>ul .item .label_box {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  position: relative;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item label {
  width: 100%;
  text-align: left;
  margin-right: 10px;
  color: #1e1e1e;
  font-size: 14px;
  margin-bottom: 5px;
}


.CAkqQEYYNHqOOJDFEr3i>ul .item label i {
  display: inline-block;
  margin-right: 10px;
  color: #7d558a;
}
input, textarea {
  outline: none;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item .tips {
  color: #99a0b1;
  margin-top: 4px;
}

.CAkqQEYYNHqOOJDFEr3i>ul .item .label_box>input {
  width: 100%;
  border: 1px solid #ccc;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  border-radius: 4px;
  padding: 0 10px;
}
.CAkqQEYYNHqOOJDFEr3i>ul .item .footer {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.CAkqQEYYNHqOOJDFEr3i>ul .item .button {
  height: 2rem;
  line-height: 2rem;
  width: 100%;
  margin-top: .53333rem;
  color: #fff;
  text-align: center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  font-size: .8rem;
  border-radius: 2rem;
  background: linear-gradient(306deg, #593f6c 0%, #947be7 100%);
}

.HZ0Aws4BaQP_ZM85k_mS {
  height: 2.4rem;
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 5;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, .22);
}

.HZ0Aws4BaQP_ZM85k_mS>div.left {
  width: 10%;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}
.HZ0Aws4BaQP_ZM85k_mS>div.left>svg {
  font-size: .8533rem;
  padding: .64rem .4rem;
}

.HZ0Aws4BaQP_ZM85k_mS>div.center {
  position: absolute;
  left: 20%;
  width: 60%;
  text-align: center;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 25.2px;
  color: #0c0319;
}
.HZ0Aws4BaQP_ZM85k_mS>div.right {
  width: 30%;
  display: flex;
  justify-content: flex-end;
}
.CAkqQEYYNHqOOJDFEr3i>ul .item.usd_type .label_box>ul li.active {
  border: 1px solid #9179e7;
  color: #775493;
}

</style>



// WEBPACK FOOTER //
// src/components/addBankCard.vue